module.exports = __webpack_public_path__ + "media/brands/gilera-dfaf91ce.png";